import type { BehaviorTrend } from '../../../lib/types/TeamBehavior';
import { TrendType } from '../components/Trend/Trend';

export const getBehaviorTrendType = (trend: BehaviorTrend) => {
  if (trend.current === 0 && trend.previous === 0) {
    return TrendType.FLAT;
  }
  if (trend.previous <= trend.current) {
    return TrendType.DOWN;
  }
  if (trend.previous > trend.current) {
    return TrendType.UP;
  }
  return TrendType.FLAT;
};

export const getBehaviorTrendPercentage = (trend: BehaviorTrend) => {
  if (trend.previous === 0) {
    return 0;
  }
  return ((trend.current - trend.previous) / trend.previous) * 100;
};
